import { useEffect, useState } from 'react';

export const getScreenSize = () => ({
  width: window.innerWidth,
  height: window.innerHeight,
});

export const useScreenSize = () => {
  const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    const onResize = () => setSize({ width: window.innerWidth, height: window.innerHeight });

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return size;
};
